import api from '../utils/api';

export const getPayrollSettings = async (projectId) => {
  const res = await api.get(`/payroll-settings/${projectId}/payroll-settings`);
  return res.data?.data?.settings || null;
};

export const updatePayrollSettings = async (projectId, payload) => {
  const res = await api.post(`/payroll-settings/${projectId}/payroll-settings`, payload);
  return res.data?.data?.settings || null;
};

export default {
  getPayrollSettings,
  updatePayrollSettings,
};
